import * as React from 'react';
import { useDispatch } from 'react-redux';
import { deleteGroup } from '../store/organization.store';
import { ModalContainer } from '@moovly/ui';
import { t } from '@moovly/i18n';
import { GroupInfo } from '@moovly/clients/lib/resources/group/group.interfaces';
import { DefaultModalProps } from '../../../types/modal';

interface DeleteOrganizationGroupModalProps extends DefaultModalProps {
  group: GroupInfo;
}

export const DeleteOrganizationGroupModal: React.FC<DeleteOrganizationGroupModalProps> = ({
  group,
  setOpen,
  closeModal,
}) => {
  const dispatch = useDispatch<any>();
  const handleConfirm = React.useCallback(() => {
    if (!!group) {
      dispatch(deleteGroup({ groupId: group.id }));
    }
    closeModal();
  }, [dispatch, closeModal, group]);
  return (
    <ModalContainer
      title={t('groups.deleteModal.title')}
      description={t('groups.deleteModal.description')}
      confirmButtonText={t('groups.deleteModal.delete')}
      onConfirm={handleConfirm}
      isOpen={!!group}
      setOpen={setOpen}
    />
  );
};

export default DeleteOrganizationGroupModal;
